import './style.scss';
import { InputHTMLAttributes, useState } from 'react';
import { IconSize, SvgIcon } from '../svgIcon';
import { IconName, findIcon } from 'views/utils/handleIcon';

export type PasswordInputProps = InputHTMLAttributes<HTMLInputElement>;

export const PasswordInput = (props: PasswordInputProps) => {
  const [isRevealPassword, setRevealPassword] = useState<boolean>(false);
  const icon = findIcon(isRevealPassword ? IconName.EyeOn : IconName.EyeOff);

  return (
    <div className={'passwordInput'}>
      <input
        className={'passwordInput_value'}
        type={isRevealPassword ? 'text' : 'password'}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        placeholder={props.placeholder}
      />

      <span onClick={() => setRevealPassword(!isRevealPassword)} className="passwordInput_action">
        <SvgIcon icon={icon} size={IconSize.icon_m} />
      </span>
    </div>
  );
};
